








import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { FormatStructureEditor } from "../../domain/editableFormat";
import { FormatEditor } from "./editors";
import { FormatEditViewMixin } from "./mixins";

@Component({
  components: {
    FormatEditor,
  },
})
export default class NewFormatEditView extends Mixins(FormatEditViewMixin) {
  @Prop()
  version: string;

  created() {
    this.load();
  }

  async load(): Promise<void> {
    // TODO: version指定されてない時どこから取る？デフォルトを設定的にどこかに持っておく？
    this.isLoading = true;
    const version = this.version
      ? this.version
      : "3.00";
    const registry = DomainRegistry.instance;
    const results = await Promise.all([
      await registry.editableFormat.getFormatRepository().getNewFormatStructure(version),
      await registry.editableFormat.getSpecificationRepository().getSpecification(version),
    ]);
    this.isLoading = false;
    this.model = new FormatStructureEditor(results[0], results[1]);
    this.model.setCommandCountMax(this.$configuration.formatEditor.behavior.format.editor.commandManager.max);
  }
}
